import { render, staticRenderFns } from "./puzzle.vue?vue&type=template&id=4ae51c02&scoped=true&"
import script from "./puzzle.vue?vue&type=script&lang=js&"
export * from "./puzzle.vue?vue&type=script&lang=js&"
import style0 from "./puzzle.vue?vue&type=style&index=0&id=4ae51c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae51c02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae51c02')) {
      api.createRecord('4ae51c02', component.options)
    } else {
      api.reload('4ae51c02', component.options)
    }
    module.hot.accept("./puzzle.vue?vue&type=template&id=4ae51c02&scoped=true&", function () {
      api.rerender('4ae51c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/puzzle.vue"
export default component.exports